import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { ApiError } from "@/shared/types";
import { handleError } from "@/shared/lib/helpers/utils";

export const fetchDraftResponse = createAsyncThunk<string, string, ThunkConfig<ApiError>>(
  "fetchDraftResponse",
  async (id, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      const response = await extra.api.get<{ personalityMessage: string }>(`/api/reading_gpt_response/${id}/newest`);

      return response.data.personalityMessage;
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
